<script setup lang="ts">
import AirSnapshot from '../components/AirSnapshot.vue';
import AirTrend from '../components/AirTrend.vue';
import SiteHeader from '../components/SiteHeader.vue';
import SiteFooter from '../components/SiteFooter.vue';
import MascotScene from '../components/MascotScene.vue';
import PunFeature from '../components/PunFeature.vue';
</script>

<template>
  <div class="page-shell">
    <SiteHeader />
    <main class="daily-board">
      <section class="hero-intro" aria-labelledby="page-title">
        <p class="eyebrow">
          <span class="edition-rule" aria-hidden="true"></span> Air Your Grievances
        </p>
        <h1 id="page-title">The air is hazy.<br /><span>The puns are worse.</span></h1>
        <p class="intro-copy">A serious look at the air. A less serious take on everything else.</p>
      </section>
      <div class="reading-wrap"><AirSnapshot :show-trend="false" /></div>
      <section class="feature-stage" aria-label="Your Merlion and a little comic relief">
        <MascotScene />
        <PunFeature />
      </section>
      <AirTrend class="standalone-trend" />
    </main>
    <SiteFooter />
  </div>
</template>
